import {useUpdateFieldsMutation} from 'components/customer/Product/store/productApi';
import {useCallback} from 'react';
import {Product} from 'components/customer/Product/entity/Product';

export const useJobCabinetFieldUpdate = (roomId: number) => {
    const [updateFieldsTrigger, {isLoading}] = useUpdateFieldsMutation();

    const updateFields = useCallback(
        async (product: Partial<Product>) => {
            const result = await updateFieldsTrigger({
                ...product,
                room_id: roomId,
            });

            if ('error' in result) {
                let error: Error;
                if (
                    typeof result.error === 'object' &&
                    'data' in result.error &&
                    typeof result.error.data === 'object'
                ) {
                    if (
                        'error' in result.error.data &&
                        typeof result.error.data.error === 'string'
                    ) {
                        error = new Error(result?.error?.data?.error);
                    } else {
                        error = new Error('Error updating fields');
                    }

                    if ('errors' in result.error.data) {
                        const errors = result.error.data.errors;
                        if (errors && Array.isArray(errors)) {
                            errors.forEach((message: string) => {
                                if (message.toLowerCase().includes('shelf')) {
                                    error.name = 'shelf-error';
                                }
                            });
                        }
                    }
                }

                throw error;
            }
        },
        [roomId]
    );

    return {
        isLoading,
        updateFields,
    };
};
